import React from 'react';
import { useTranslation } from 'react-i18next';
import Badge, { BadgeType } from '../../components/ui/Badge/Badge';

// Units the warehouse stored beyond the announced quantity (spec 2026-10-19 D).
// Renders nothing without a surplus and while the backend does not send the
// field yet. Own module like NotAnnouncedBadge so table and overlay can both
// import it without a cycle.
export function ExtraUnitsBadge({ extra }: { extra?: number }) {
  const { t } = useTranslation();
  if (!extra || extra <= 0) return null;
  return <Badge label={t('inbound.extra_units', { count: extra })} type={BadgeType.Warning} expanded />;
}

export default ExtraUnitsBadge;
